module.exports = __webpack_public_path__ + "static/img/i125.0e4faab2.png";